import React from 'react';
import Layout from '../../scaffolding/Layout';

const Contact = () => {
  return <Layout>Contact</Layout>;
};

export default Contact;
